<template>
	<div v-if="loading" class="loading d-flex">
		<div class="loading-dots justify-content-center align-self-center">
			<div class="dot"></div>
			<div class="dot"></div>
			<div class="dot"></div>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		loading:Boolean,
	}
}
</script>

<style>
	.loading{
		z-index:1011;
	}
</style>


// WEBPACK FOOTER //
// src/components/content/content-loading.vue